import { useEffect } from 'react';

const SEO = ({ title, description, keywords, canonical, ogTitle, ogDescription }) => {
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update or create meta tags
    const updateMetaTag = (name, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    
    const updatePropertyTag = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    
    const updateLinkTag = (rel, href) => {
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.href = href;
    };
    
    // Update meta tags
    if (description) updateMetaTag('description', description);
    if (keywords) updateMetaTag('keywords', keywords);
    
    // Update Open Graph tags
    if (ogTitle) updatePropertyTag('og:title', ogTitle);
    if (ogDescription) updatePropertyTag('og:description', ogDescription);
    updatePropertyTag('og:type', 'website');
    
    // Update canonical URL
    if (canonical) updateLinkTag('canonical', canonical);
    
  }, [title, description, keywords, canonical, ogTitle, ogDescription]);
  
  return null;
};

export default SEO;
